export default "__VITE_ASSET__BXgJFi4R__"